import { NomadDB } from '~/db/NomadDB.js';
import type { RecommendationParameterSchema } from '@/types/schema';

export const getRecommendationParametersService = (db: NomadDB) => {
  const get = async (params: any): Promise<RecommendationParameterSchema> => {
    return await db.recommendationParameters.get(params);
  };

  const findByTypesAndIds = async (
    typesAndIds: string[][]
  ): Promise<RecommendationParameterSchema[]> => {
    const recommendationParameters = await db.recommendationParameters
      .where(['type+id'])
      .anyOf(typesAndIds)
      .toArray();
    return recommendationParameters;
  };

  const put = async (
    recommendationParameters: RecommendationParameterSchema
  ): Promise<any> => {
    return await db.recommendationParameters.put(recommendationParameters);
  };

  const findWhere = async (
    params: object
  ): Promise<RecommendationParameterSchema[]> => {
    return await db.recommendationParameters.where(params).toArray();
  };

  const bulkPut = async (
    parameters: RecommendationParameterSchema[]
  ): Promise<void> => {
    await db.recommendationParameters.bulkPut(parameters);
  };

  return {
    get,
    put,
    findByTypesAndIds,
    findWhere,
    bulkPut,
  };
};
